import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { ButtonGroup, Button, Dialog, DialogActions, DialogContent, DialogTitle, FlexRow, InputGroup, TextField } from './Styles/ChangeCreditLimitDialogBox';

import { updateDSOConfig } from '../../../actions/dsoActions';
import { formatCurrency, stripCurrency } from '../../../commons/utils';

const ChangeCreditLimitDialogBox = ({ open, dso, onTrue, onFalse, ...props }) => {
	const [value, setValue] = useState('');
	const [error, setError] = useState('');

	const onTrueHandler = async () => {
		let newValue = stripCurrency(value);
		if (newValue === 0 || newValue === '' || newValue === null) setError('Limit cannot be zero or empty.');
		else {
			let requestObj = {
				credit_limit: newValue,
			};
			await props.updateDSOConfig(dso, requestObj);
			onTrue();
		}
	};

	const onFalseHandler = () => {
		onFalse();
	};

	useEffect(() => {
		setValue('');
	}, [open]);

	return (
		<Dialog
			open={open}
			onClose={() => onFalseHandler()}
			fullWidth
		>
			<DialogTitle>
				Change Credit Limit
			</DialogTitle>

			<DialogContent style={{ marginTop: '-30px' }}>
				<FlexRow style={{ padding: '0 1rem' }}>
					<InputGroup
						label='New Credit Limit'
						markRequired={true}
						error={error}
					>
						<TextField
							name={'credit_limit'}
							disabled={false}
							placeholder='$0.00'
							value={formatCurrency(value) || ''}
							onBlur={(e) => {
								setValue(stripCurrency(formatCurrency(e.target.value, true)));
							}}
							onChange={(e) => {
								setValue(formatCurrency(e.target.value));
							}}
							error={error}
						/>
					</InputGroup>
				</FlexRow>
			</DialogContent>

			<DialogActions style={{ margin: '0 0.5rem' }}>
				<ButtonGroup alignRight>
					<Button
						primary
						outline
						onClick={(e) => onFalseHandler()}
					>
						Cancel
					</Button>
					<Button
						primary
						onClick={(e) => onTrueHandler()}
					>
						Done
					</Button>
				</ButtonGroup>
			</DialogActions>
		</Dialog>
	);
};

const mapStatesToProps = (state) => {
	return {
		supplier: state.supplier.supplier,
	};
};

const mapFunctionsToProps = {
	updateDSOConfig,
};

export default connect(mapStatesToProps, mapFunctionsToProps)(ChangeCreditLimitDialogBox);
